import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
/* eslint-disable prefer-arrow/prefer-arrow-functions */


function fixArrayType(array) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return array;
}
/* eslint-enable prefer-arrow/prefer-arrow-functions */

/**
 * @internalapi
 *
 * The StorageManager provides CRUD functionality for specific entities and persists them to the provided storage.
 */


export var StorageManager = /*#__PURE__*/function () {
  function StorageManager(storage, storageKey) {
    _classCallCheck(this, StorageManager);

    this.storage = storage;
    this.storageKey = storageKey;
  }

  _createClass(StorageManager, [{
    key: "getAll",
    value: function getAll() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", this.storage.get(this.storageKey));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "getOne",
    value: function getOne(predicate) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var entities;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.storage.get(this.storageKey);

              case 2:
                entities = _context2.sent;
                return _context2.abrupt("return", fixArrayType(entities).find(predicate));

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
  }, {
    key: "addOne",
    value: function addOne(element, predicate) {
      var overwrite = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var entities, i;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.storage.get(this.storageKey);

              case 2:
                entities = _context3.sent;

                if (!fixArrayType(entities).some(predicate)) {
                  fixArrayType(entities).push(element);
                } else if (overwrite) {
                  for (i = 0; i < entities.length; i++) {
                    if (predicate(fixArrayType(entities)[i])) {
                      entities[i] = element;
                    }
                  }
                }

                return _context3.abrupt("return", this.storage.set(this.storageKey, entities));

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    }
  }, {
    key: "remove",
    value: function remove(predicate) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var entities, filteredEntities;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.storage.get(this.storageKey);

              case 2:
                entities = _context4.sent;
                filteredEntities = fixArrayType(entities).filter(function (entity) {
                  return !predicate(entity);
                }); // eslint-disable-next-line @typescript-eslint/no-explicit-any

                return _context4.abrupt("return", this.storage.set(this.storageKey, filteredEntities));

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));
    }
  }, {
    key: "removeAll",
    value: function removeAll() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                return _context5.abrupt("return", this.storage.delete(this.storageKey));

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));
    }
  }]);

  return StorageManager;
}();